import './Hero.css';
import heroImage from '../../assets/hero-led.jpg';

const Hero = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5531972035157';
    const message = 'Olá, gostaria de fazer um orçamento de painéis de LED.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const scrollToContact = () => {
    document.querySelector('#contato').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="hero__bg">
        <img src={heroImage} alt="Painel de LED de alta definição iluminando palco de evento corporativo" fetchpriority="high" />
        <div className="hero__overlay"></div>
      </div>

      <div className="hero__container">
        <div className="hero__content" data-aos="fade-up" data-aos-duration="800">
          <div className="hero__badge">
            <i className="fas fa-star"></i>
            +10 anos de experiência no mercado
          </div>

          <h1>
            Impacto visual que transforma
            <span className="hero__highlight"> negócios e eventos</span>
          </h1>

          <p className="hero__description">
            Locação de painéis de LED de alta definição para eventos, shoppings, igrejas,
            publicidade e comunicação visual. Tecnologia de ponta e suporte completo.
          </p>

          <div className="hero__actions">
            <button className="button-primary hero__btn-primary" onClick={handleWhatsAppClick}>
              <i className="fab fa-whatsapp"></i>
              Solicitar Orçamento Grátis
            </button>
            <button className="button-secondary" onClick={scrollToContact}>
              <i className="fas fa-play-circle"></i>
              Fale com um Especialista
            </button>
          </div>

          <div className="hero__trust">
            <div className="hero__trust-item">
              <i className="fas fa-check-circle"></i>
              <span>Orçamento sem compromisso</span>
            </div>
            <div className="hero__trust-item">
              <i className="fas fa-check-circle"></i>
              <span>Entrega e montagem inclusa</span>
            </div>
            <div className="hero__trust-item">
              <i className="fas fa-check-circle"></i>
              <span>Suporte técnico 24h</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
